export function brandForTheme(color: string) {
  return {
    color,
    iconTone: isNeutralBrandColor(color) ? "grey" : "gold",
  } as const;
}

function isNeutralBrandColor(color: string) {
  const hex = color.trim().replace("#", "");
  const normalized =
    hex.length === 3
      ? hex
          .split("")
          .map((digit) => digit.repeat(2))
          .join("")
      : hex;
  if (!/^[0-9a-f]{6}$/i.test(normalized)) return false;

  const channels = [0, 2, 4].map((index) =>
    Number.parseInt(normalized.slice(index, index + 2), 16),
  );
  return Math.max(...channels) - Math.min(...channels) <= 12;
}
